import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type PageHeaderProps = {
    eyebrow?: string
    title: string
    description?: ReactNode
    actions?: ReactNode
    className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({ eyebrow, title, description, actions, className }): ReactNode => {
    return (
        <div className={cn('mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between', className)}>
            <div className='min-w-0'>
                {eyebrow && (
                    <p className='text-[11px] font-bold tracking-[0.14em] text-primary uppercase'>
                        {eyebrow}
                    </p>
                )}

                <h1 className='mt-1 text-2xl leading-tight font-bold tracking-tight text-foreground sm:text-[1.75rem]'>
                    {title}
                </h1>

                {description && (
                    <p className='mt-1.5 max-w-2xl text-sm leading-relaxed text-muted-foreground'>
                        {description}
                    </p>
                )}
            </div>

            {actions && (
                <div className='flex flex-wrap items-center gap-2 print:hidden'>
                    {actions}
                </div>
            )}
        </div>
    )
}
